const en = {
  warning: {
    start1: "The certificate you registered is about to expire. To avoid affecting the withdrawal, ",
    start2: "The certificate you registered has expired and the withdrawal service has been closed temporarily, ",
    middle: "click here ",
    end: "to update the certificate.",
  },
  alertInfo: {
    submit: "Update",
    title: "Your certificate",
    status1: " has expired",
    status2: " is about to expire",
    label: "The",
    label1: " Legal person's ID infomation",
    label2: " Shareholder's ID infomation",
    label2_1: "Director's ID infomation",
    label3: " Beneficial owner's ID infomation",
    label4: " business registration information",
    label5: " that you registered",
    label6: "To avoid affecting the withdrawal, please update the ID in time.",
    label7: "and the withdrawal service has been closed temporarily. Please update the latest ID information as soon as possible. After the latest ID information is updated and approved, we will resume the withdrawal service for you. Thank you for your cooperation!",
  },
}
export default en